import React from "react";
import { ReactController } from "./react_controller";
import { ToastManagerRoot } from "../components/DownloadTray/ToastManagerRoot";

export class ToastManagerController extends ReactController {
  connect() {
    this.root.render(<ToastManagerRoot />);
  }
}

